import { useState, useEffect, useRef } from "react";
import { MONTHS, apiFetch, norm } from "./utils";
import { BRAND, KofidesLogo, Lbl, Inp, Slct, Btn, Card, KPI } from "./ui";
import { extraerUUIDdePDF } from "./pdfUtils";

var REGIMENES = [
  {v:"601",l:"601 - General de Ley Personas Morales"},
  {v:"603",l:"603 - Personas Morales con Fines no Lucrativos"},
  {v:"605",l:"605 - Sueldos y Salarios e Ingresos Asimilados"},
  {v:"606",l:"606 - Arrendamiento"},
  {v:"612",l:"612 - Personas Fisicas con Actividades Empresariales"},
  {v:"616",l:"616 - Sin obligaciones fiscales"},
  {v:"621",l:"621 - Incorporacion Fiscal"},
  {v:"626",l:"626 - Regimen Simplificado de Confianza"},
];

var CFDI_TABS = [
  {k:"importar",        l:"Importar"},
  {k:"ingresos",        l:"Ingresos"},
  {k:"gastos",          l:"Gastos"},
  {k:"cobros",          l:"Cobros"},
  {k:"pagos",           l:"Pagos realizados"},
  {k:"notas_emitidas",  l:"Notas emitidas"},
  {k:"notas_recibidas", l:"Notas recibidas"},
  {k:"nomina_patron",   l:"Nomina patron"},
  {k:"nomina_empleado", l:"Nomina empleado"},
];

var CAT_LABELS = {ingresos:"Ingresos",gastos:"Gastos",cobros:"Cobros",pagos:"Pagos realizados",notas_emitidas:"Notas emitidas",notas_recibidas:"Notas recibidas",nomina_patron:"Nomina patron",nomina_empleado:"Nomina empleado"};

function cfdiToMXN(n) {
  return "$" + Number(n).toLocaleString("es-MX", {minimumFractionDigits:2});
}
function cfdiDate(d) {
  if (!d) return "—";
  var p = d.split("T")[0].split("-");
  return p.length === 3 ? p[2]+"-"+p[1]+"-"+p[0] : d;
}

function parseCFDIcsv(text) {
  var lines = text.split("\n").filter(function(l){return l.trim();});
  if (lines.length < 2) return [];
  var sep = lines[0].includes("~") ? "~" : ",";
  var headers = lines[0].split(sep).map(function(h){return h.trim().replace(/"/g,"").toLowerCase();});
  var result = [];
  var tm = {INGRESO:"I",EGRESO:"E",PAGO:"P",NOMINA:"N",TRASLADO:"T",I:"I",E:"E",P:"P",N:"N",T:"T"};
  for (var i = 1; i < lines.length; i++) {
    var vals = lines[i].split(sep).map(function(v){return v.replace(/"/g,"").trim();});
    var o = {};
    headers.forEach(function(h,idx){o[h]=vals[idx]||"";});
    var ef = (o["efectocomprobante"]||o["efecto del comprobante"]||o["efecto"]||"I").toUpperCase();
    var est = o["estatus"]||"1";
    est = (est==="0")?"Cancelado":(est==="1")?"Vigente":est;
    result.push({
      uuid:           o["uuid"]||o["folio fiscal"]||"",
      tipo:           tm[ef]||"I",
      rfcEmisor:      o["rfcemisor"]||o["rfc emisor"]||"",
      nombreEmisor:   o["nombreemisor"]||o["nombre o razon social del emisor"]||"",
      rfcReceptor:    o["rfcreceptor"]||o["rfc receptor"]||"",
      nombreReceptor: o["nombrereceptor"]||o["nombre o razon social del receptor"]||"",
      usoCFDI:        o["usocfdi"]||"",
      fecha:          o["fechaemision"]||o["fecha y hora de emision"]||"",
      fechaTimbrado:  o["fechacertificacionsat"]||"",
      total:          parseFloat(o["monto"]||0),
      subtotal:       parseFloat(o["monto"]||0),
      iva:0, descuento:0,
      estatus:        est,
      metodoPago:     o["metodopago"]||"",
      formaPago:      o["formapago"]||"",
      moneda:         o["moneda"]||"MXN",
      tipoCambio:     o["tipocambio"]||"1",
      serie:          o["serie"]||"",
      folio:          o["folio"]||"",
      pacCertifico:   o["paccertifico"]||"",
      regimenFiscalEmisor:"", lugarExpedicion:"",
      regimenFiscalReceptor:"", domicilioFiscalReceptor:"",
      conceptos:[{claveProdServ:"—",claveUnidad:"—",unidad:"—",descripcion:"Ver XML original",cantidad:1,valorUnitario:parseFloat(o["monto"]||0),importe:parseFloat(o["monto"]||0)}],
      timbre:{uuid:o["uuid"]||"",noCertSAT:"",noCertEmisor:"",selloSAT:""},
      _raw:null,
    });
  }
  return result;
}

function parseCFDIxml(txt) {
  try {
    var doc = (new DOMParser()).parseFromString(txt, "text/xml");
    var comp = doc.querySelector("Comprobante")||doc.getElementsByTagNameNS("*","Comprobante")[0];
    if (!comp) { return null; }
    var em = doc.querySelector("Emisor")||doc.getElementsByTagNameNS("*","Emisor")[0];
    var re = doc.querySelector("Receptor")||doc.getElementsByTagNameNS("*","Receptor")[0];
    var tiNodes=doc.getElementsByTagName("tfd:TimbreFiscalDigital");
    if(!tiNodes.length) tiNodes=doc.getElementsByTagName("TimbreFiscalDigital");
    var ti=tiNodes[0]||null;
    var cons = Array.from(doc.querySelectorAll("Concepto")).map(function(c){
      return {
        claveProdServ: c.getAttribute("ClaveProdServ")||"",
        claveUnidad:   c.getAttribute("ClaveUnidad")||"",
        unidad:        c.getAttribute("Unidad")||"",
        descripcion:   c.getAttribute("Descripcion")||"",
        cantidad:      parseFloat(c.getAttribute("Cantidad")||1),
        valorUnitario: parseFloat(c.getAttribute("ValorUnitario")||0),
        importe:       parseFloat(c.getAttribute("Importe")||0),
        descuento:     parseFloat(c.getAttribute("Descuento")||0),
        objetoImp:     c.getAttribute("ObjetoImp")||"02",
      };
    });
    var tr = doc.querySelector("Traslado");
    var retNodes = Array.from(doc.querySelectorAll("Retenciones Retencion"));
    var retenciones = retNodes.map(function(r){return {impuesto:r.getAttribute("Impuesto")||"",importe:parseFloat(r.getAttribute("Importe")||0)};});
    var ivaRet=retenciones.filter(function(r){return r.impuesto==="002";}).reduce(function(s,r){return s+r.importe;},0);
    var isrRet=retenciones.filter(function(r){return r.impuesto==="001";}).reduce(function(s,r){return s+r.importe;},0);
    var pagosNode = doc.getElementsByTagNameNS("*","Pagos")[0]||null;
    var pagos = pagosNode ? Array.from(pagosNode.getElementsByTagNameNS("*","Pago")).map(function(pg){
      return {
        fechaPago:    pg.getAttribute("FechaPago")||"",
        formaDePagoP: pg.getAttribute("FormaDePagoP")||"",
        monedaP:      pg.getAttribute("MonedaP")||"MXN",
        tipoCambioP:  pg.getAttribute("TipoCambioP")||"1",
        monto:        parseFloat(pg.getAttribute("Monto")||0),
        doctosRelacionados: Array.from(pg.getElementsByTagNameNS("*","DoctoRelacionado")).map(function(dr){
          var trasDR = Array.from(dr.getElementsByTagNameNS("*","TrasladoDR"));
          var retDR  = Array.from(dr.getElementsByTagNameNS("*","RetencionDR"));
          var ivaTras = trasDR.filter(function(t){return t.getAttribute("ImpuestoDR")==="002"&&t.getAttribute("TipoFactorDR")!=="Exento";});
          var ivaExentoNodos = trasDR.filter(function(t){return t.getAttribute("ImpuestoDR")==="002"&&t.getAttribute("TipoFactorDR")==="Exento";});
          return {
            idDocumento:      dr.getAttribute("IdDocumento")||"",
            serie:            dr.getAttribute("Serie")||"",
            folio:            dr.getAttribute("Folio")||"",
            monedaDR:         dr.getAttribute("MonedaDR")||"",
            numParcialidad:   dr.getAttribute("NumParcialidad")||"",
            impSaldoAnt:      parseFloat(dr.getAttribute("ImpSaldoAnt")||0),
            impPagado:        parseFloat(dr.getAttribute("ImpPagado")||0),
            impSaldoInsoluto: parseFloat(dr.getAttribute("ImpSaldoInsoluto")||0),
            baseIva16:        ivaTras.reduce(function(s,t){return s+parseFloat(t.getAttribute("BaseDR")||0);},0),
            ivaTrasladado16:  ivaTras.reduce(function(s,t){return s+parseFloat(t.getAttribute("ImporteDR")||0);},0),
            ivaExento:        ivaExentoNodos.reduce(function(s,t){return s+parseFloat(t.getAttribute("BaseDR")||0);},0),
            ivaRetenido:      retDR.filter(function(r){return r.getAttribute("ImpuestoDR")==="002";}).reduce(function(s,r){return s+parseFloat(r.getAttribute("ImporteDR")||0);},0),
            isrRetenido:      retDR.filter(function(r){return r.getAttribute("ImpuestoDR")==="001";}).reduce(function(s,r){return s+parseFloat(r.getAttribute("ImporteDR")||0);},0),
          };
        }),
      };
    }) : [];
    var pagosTotalesNode = pagosNode ? pagosNode.getElementsByTagNameNS("*","Totales")[0] : null;
    var montoTotalPagos = pagosTotalesNode ? parseFloat(pagosTotalesNode.getAttribute("MontoTotalPagos")||0) : pagos.reduce(function(s,pg){return s+pg.monto;},0);
    var parsedCfdi = {
      uuid:                    ti ? (ti.getAttribute("UUID")||"").toUpperCase() : "",
      tipo:                    comp.getAttribute("TipoDeComprobante")||"I",
      rfcEmisor:               em ? em.getAttribute("Rfc") : "",
      nombreEmisor:            em ? em.getAttribute("Nombre") : "",
      regimenFiscalEmisor:     em ? em.getAttribute("RegimenFiscal") : "",
      rfcReceptor:             re ? re.getAttribute("Rfc") : "",
      nombreReceptor:          re ? re.getAttribute("Nombre") : "",
      usoCFDI:                 re ? re.getAttribute("UsoCFDI") : "",
      regimenFiscalReceptor:   re ? re.getAttribute("RegimenFiscalReceptor") : "",
      domicilioFiscalReceptor: re ? re.getAttribute("DomicilioFiscalReceptor") : "",
      lugarExpedicion:         comp.getAttribute("LugarExpedicion")||"",
      fecha:                   comp.getAttribute("Fecha")||"",
      fechaTimbrado:           ti ? ti.getAttribute("FechaTimbrado") : "",
      subtotal:                parseFloat(comp.getAttribute("SubTotal")||0),
      total:                   (comp.getAttribute("TipoDeComprobante")||"I")==="P" ? montoTotalPagos : parseFloat(comp.getAttribute("Total")||0),
      descuento:               parseFloat(comp.getAttribute("Descuento")||0),
      iva:                     tr ? parseFloat(tr.getAttribute("Importe")||0) : 0,
      ivaRetenido:             ivaRet,
      isrRetenido:             isrRet,
      retenciones:             retenciones,
      estatus:                 "Vigente",
      metodoPago:              comp.getAttribute("MetodoPago")||"",
      formaPago:               comp.getAttribute("FormaPago")||"",
      moneda:                  comp.getAttribute("Moneda")||"MXN",
      tipoCambio:              comp.getAttribute("TipoCambio")||"1",
      serie:                   comp.getAttribute("Serie")||"",
      folio:                   comp.getAttribute("Folio")||"",
      pacCertifico:            "",
      conceptos: cons.length ? cons : [{claveProdServ:"",claveUnidad:"",unidad:"",descripcion:"Sin conceptos",cantidad:1,valorUnitario:0,importe:0}],
      exportacion: comp.getAttribute("Exportacion")||"",
      pagos: pagos,
      montoTotalPagos: montoTotalPagos,
      timbre:{
        uuid:           ti ? (ti.getAttribute("UUID")||"").toUpperCase() : "",
        noCertSAT:      ti ? ti.getAttribute("NoCertificadoSAT") : "",
        noCertEmisor:   comp.getAttribute("NoCertificado")||"",
        selloSAT:       ti ? ti.getAttribute("SelloSAT") : "",
        selloCFD:       ti ? ti.getAttribute("SelloCFD") : "",
        cadenaOriginal: (function(){try{var m=txt.match(/\|\|[^<>"]{10,}/);return m?m[0]:"";}catch(e){return "";}}()),
      },
      _raw: txt,
    };
    return parsedCfdi;
  } catch(e) { return null; }
}

export function classifyCFDIs(list, myRfc) {
  var my = (myRfc||"").toUpperCase();
  var result = list.map(function(c){
    var t = (c.tipo||"I").toUpperCase();
    var em = my && (c.rfcEmisor||"").toUpperCase() === my;
    var cat;
    if (!my)           cat = {I:"ingresos",E:"notas_emitidas",P:"cobros",N:"nomina_patron"}[t]||"ingresos";
    else if (t==="I")  cat = em ? "ingresos"       : "gastos";
    else if (t==="E")  cat = em ? "notas_emitidas" : "notas_recibidas";
    else if (t==="P")  cat = em ? "cobros"         : "pagos";
    else if (t==="N")  cat = em ? "nomina_patron"  : "nomina_empleado";
    else               cat = em ? "ingresos"       : "gastos";
    return Object.assign({}, c, {categoria: cat});
  });
  return result;
}

function CFDIConfigModal(p) {
  var [rfc, setRfc] = useState(p.cfg.rfc||"");
  var [nom, setNom] = useState(p.cfg.nombre||"");
  var [reg, setReg] = useState(p.cfg.regimen||"");
  var [cp,  setCp]  = useState(p.cfg.cp||"");
  function save() {
    p.onSave({rfc:rfc.trim().toUpperCase(), nombre:nom.trim(), regimen:reg, cp:cp.trim()});
  }
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,padding:28,width:"100%",maxWidth:440,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h2 style={{fontSize:16,fontWeight:700,margin:0}}>Configuracion fiscal</h2>
          <button onClick={p.onClose} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:"#94a3b8"}}>X</button>
        </div>
        <div style={{display:"grid",gap:14}}>
          <div><Lbl c="RFC"/><Inp placeholder="XAXX010101000" maxLength={13} value={rfc} onChange={function(e){setRfc(e.target.value.toUpperCase());}}/></div>
          <div><Lbl c="Razon social / Nombre"/><Inp placeholder="Mi Empresa S.A. de C.V." value={nom} onChange={function(e){setNom(e.target.value);}}/></div>
          <div>
            <Lbl c="Regimen fiscal"/>
            <Slct value={reg} onChange={function(e){setReg(e.target.value);}}>
              <option value="">Seleccionar...</option>
              {REGIMENES.map(function(r){return <option key={r.v} value={r.v}>{r.l}</option>;})}
            </Slct>
          </div>
          <div><Lbl c="Codigo postal"/><Inp placeholder="45010" maxLength={5} value={cp} onChange={function(e){setCp(e.target.value.replace(/\D/g,""));}}/></div>
        </div>
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <button onClick={p.onClose} style={{flex:1,padding:"10px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
          <Btn onClick={save} sx={{flex:2,padding:"10px 0",borderRadius:9}}>Guardar</Btn>
        </div>
      </div>
    </div>
  );
}

function CFDIPDFCell(p) {
  var uid = p.uid;
  var cfdi = p.cfdi;
  var uuid = cfdi.uuid;
  var [hasPdf, setHasPdf] = useState(null); // null=desconocido, true/false
  var [downloading, setDownloading] = useState(false);

  // Verificar existencia al montar
  useEffect(function() {
    if (!uuid || uuid === "—") { setHasPdf(false); return; }
    apiFetch("/cfdi/pdf/" + uid + "/" + uuid + "/exists")
      .then(function(r) { return r.json(); })
      .then(function(d) { setHasPdf(!!d.exists); })
      .catch(function() { setHasPdf(false); });
  }, [uid, uuid]);

  function handlePDFClick() {
    if (!hasPdf || downloading) return;
    setDownloading(true);
    apiFetch("/cfdi/pdf/" + uid + "/" + uuid)
      .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.blob(); })
      .then(function(blob){
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url; a.download = "CFDI_" + uuid.substring(0,8) + ".pdf";
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(function(){})
      .finally(function(){ setDownloading(false); });
  }

  var available = hasPdf === true;
  return (
    <span>
      <button onClick={handlePDFClick} disabled={!available || downloading}
        title={available ? "Descargar PDF" : "PDF no disponible"}
        style={{background:"none",border:"none",cursor:available&&!downloading?"pointer":"default",fontSize:16,padding:"2px 3px",opacity:available?1:0.25}}>
        🖨️
      </button>
    </span>
  );
}

function CFDITabla(p) {
  var lista=p.lista||[]; var isCob=p.cat==="cobros"||p.cat==="pagos";
  var [sortCol,setSortCol]=useState("fecha"); var [sortDir,setSortDir]=useState("desc");
  var [colF,setColF]=useState({}); var [desde,setDesde]=useState(""); var [hasta,setHasta]=useState("");
  var [expanded,setExpanded]=useState({});
  function toggleExp(uuid){setExpanded(function(e){return Object.assign({},e,{[uuid]:!e[uuid]});});}
  var facturaByUuid={};
  (p.all||lista).forEach(function(c){facturaByUuid[c.uuid]={serie:c.serie,folio:c.folio};});
  function facturaLabel(uuid){
    var f=facturaByUuid[uuid];
    if(f&&(f.serie||f.folio)) return [f.serie,f.folio].filter(Boolean).join("-");
    return uuid?uuid.slice(0,8)+"…":"—";
  }
  var COLS_GENERIC=[
    {k:"tipo",    l:"Tipo",                   g:function(c){return {I:"Ingreso",E:"Egreso",P:"Pago",N:"Nomina",T:"Traslado"}[c.tipo]||c.tipo;}},
    {k:"serie",   l:"Serie+Folio",            g:function(c){return [c.serie,c.folio].filter(Boolean).join("-")||"—";}},
    {k:"fecha",   l:"Fecha",                  g:function(c){return cfdiDate(c.fecha);}, r:function(c){return c.fecha||"";}},
    {k:"rfcEm",   l:"RFC Emisor",             g:function(c){return c.rfcEmisor||"—";}},
    {k:"nomEm",   l:"Nombre Emisor",          g:function(c){return c.nombreEmisor||"—";}},
    {k:"rfcRec",  l:"RFC Receptor",           g:function(c){return c.rfcReceptor||"—";}},
    {k:"nomRec",  l:"Razon Social Receptor",  g:function(c){return c.nombreReceptor||"—";}},
    {k:"uso",     l:"Uso CFDI",               g:function(c){return c.usoCFDI||"—";}},
    {k:"metPago", l:"Metodo Pago",            g:function(c){return c.metodoPago||"—";}},
    {k:"frmPago", l:"Forma Pago",             g:function(c){return c.formaPago||"—";}},
    {k:"sub",     l:"Subtotal",               g:function(c){return cfdiToMXN(c.subtotal||0);}, r:function(c){return c.subtotal||0;}},
    {k:"desc",    l:"Descuento",              g:function(c){return cfdiToMXN(c.descuento||0);}, r:function(c){return c.descuento||0;}},
    {k:"iva",     l:"IVA",                    g:function(c){return cfdiToMXN(c.iva||0);}, r:function(c){return c.iva||0;}},
    {k:"ivaRet",  l:"IVA Retenido",           g:function(c){return c.ivaRetenido!=null?cfdiToMXN(c.ivaRetenido):"—";}, r:function(c){return c.ivaRetenido||0;}},
    {k:"isrRet",  l:"ISR Retenido",           g:function(c){return c.isrRetenido!=null?cfdiToMXN(c.isrRetenido):"—";}, r:function(c){return c.isrRetenido||0;}},
    {k:"total",   l:"Total",                  g:function(c){return cfdiToMXN(c.total||0);}, r:function(c){return c.total||0;}},
    {k:"mes",     l:"Mes Pago",               g:function(c){var f=c.fecha||""; var m=parseInt(f.slice(5,7),10)-1; return f?MONTHS[m]+" "+f.slice(0,4):"—";}, r:function(c){return c.fecha?c.fecha.slice(0,7):""}},
    {k:"estatus", l:"Estatus",                g:function(c){return c.estatus||"—";}},
    {k:"uuid",    l:"UUID",                   g:function(c){return c.uuid?c.uuid.slice(0,8)+"…":"—";}, t:function(c){return c.uuid||"";}},
  ];
  var COLS_PAGOS=[
    {k:"uso",        l:"Uso CFDI",             g:function(c){return c.usoCFDI||"—";}},
    {k:"uuidRep",    l:"UUID REP",             g:function(c){return c.uuid?c.uuid.slice(0,8)+"…":"—";}, t:function(c){return c.uuid||"";}},
    {k:"folioRep",   l:"Folio REP",            g:function(c){return [c.serie,c.folio].filter(Boolean).join("-")||"—";}},
    {k:"regRec",     l:"Regimen receptor",     g:function(c){return c.regimenFiscalReceptor||"—";}},
    {k:"rfcRec",     l:"RFC receptor",         g:function(c){return c.rfcReceptor||"—";}},
    {k:"razonRec",   l:"Razon receptor",       g:function(c){return c.nombreReceptor||"—";}},
    {k:"fecha",      l:"Fecha emision REP",    g:function(c){return cfdiDate(c.fecha);}, r:function(c){return c.fecha||"";}},
    {k:"estatus",    l:"Estado REP",           g:function(c){return c.estatus||"—";}},
    {k:"frmPagoP",   l:"Forma de pago",        g:function(c){return (c.pagos&&c.pagos[0]&&c.pagos[0].formaDePagoP)||"—";}},
    {k:"monedaP",    l:"Moneda pago",          g:function(c){return (c.pagos&&c.pagos[0]&&c.pagos[0].monedaP)||"—";}},
    {k:"tipoCambioP",l:"Tipo cambio pago",     g:function(c){return (c.pagos&&c.pagos[0])?c.pagos[0].tipoCambioP:"—";}, r:function(c){return c.pagos&&c.pagos[0]?parseFloat(c.pagos[0].tipoCambioP||1):0;}},
    {k:"impPagado",  l:"Importe pagado",       g:function(c){return cfdiToMXN(c.montoTotalPagos||0);}, r:function(c){return c.montoTotalPagos||0;}},
    {k:"fechaPago",  l:"Fecha pago",           g:function(c){return (c.pagos&&c.pagos[0])?cfdiDate(c.pagos[0].fechaPago):"—";}, r:function(c){return c.pagos&&c.pagos[0]?c.pagos[0].fechaPago:"";}},
    {k:"numDoctoRel",l:"No. Docto Relacionado",g:function(c){return String((c.pagos||[]).reduce(function(s,pg){return s+(pg.doctosRelacionados||[]).length;},0));}, r:function(c){return (c.pagos||[]).reduce(function(s,pg){return s+(pg.doctosRelacionados||[]).length;},0);}},
  ];
  var COLS=isCob?COLS_PAGOS:COLS_GENERIC;
  function setF(k,v){setColF(function(f){return Object.assign({},f,{[k]:v});});}
  function doSort(k){if(sortCol===k){setSortDir(function(d){return d==="asc"?"desc":"asc";});}else{setSortCol(k);setSortDir("asc");}}
  var filt=lista.filter(function(c){
    var fd=(c.fecha||"").slice(0,10);
    if(desde&&fd<desde)return false;
    if(hasta&&fd>hasta)return false;
    return COLS.every(function(col){var v=colF[col.k]||""; return !v||norm(col.g(c)).includes(norm(v));});
  });
  var sorted=filt.slice().sort(function(a,b){
    var col=COLS.find(function(c){return c.k===sortCol;}); if(!col)return 0;
    var av=col.r?col.r(a):col.g(a); var bv=col.r?col.r(b):col.g(b);
    var cmp=typeof av==="number"?av-bv:String(av).localeCompare(String(bv),"es");
    return sortDir==="asc"?cmp:-cmp;
  });
  if(!lista.length) return <div style={{textAlign:"center",padding:"40px 0",color:"#94a3b8",fontSize:13}}>Sin CFDIs en esta categoria.</div>;
  var arr=function(k){if(sortCol!==k)return <span style={{color:"#cbd5e1",marginLeft:2}}>↕</span>; return <span style={{marginLeft:2}}>{sortDir==="asc"?"↑":"↓"}</span>;};
  var totalCols=COLS.length+1+(isCob?1:0);
  var rows=sorted.map(function(c,i){
    var esCanc=(c.estatus||"").toLowerCase().includes("cancel");
    var isExp=isCob&&!!expanded[c.uuid];
    var out=[
      <tr key={c.uuid+i} style={{borderBottom:isExp?"none":"1px solid #f0f0f0"}} onMouseEnter={function(e){e.currentTarget.style.background="#fafbff";}} onMouseLeave={function(e){e.currentTarget.style.background="transparent";}}>
        {isCob?(
          <td style={{padding:"8px 4px",textAlign:"center",cursor:"pointer",color:"#64748b",userSelect:"none"}} onClick={function(){toggleExp(c.uuid);}}>{isExp?"▾":"▸"}</td>
        ):null}
        {COLS.map(function(col){
          var val=col.g(c);
          if(col.k==="tipo") return <td key={col.k} style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:"#f0f0f0",color:"#555"}}>{val}</span></td>;
          if(col.k==="estatus") return <td key={col.k} style={{padding:"8px 10px"}}><span style={{fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:500,background:esCanc?"#FCEBEB":"#EAF3DE",color:esCanc?"#A32D2D":"#3B6D11"}}>{val}</span></td>;
          var isNum=["sub","desc","iva","ivaRet","isrRet","total","impPagado","tipoCambioP","numDoctoRel"].indexOf(col.k)!==-1;
          if(col.k==="fechaPago"&&c.pagos&&c.pagos.length>1){
            return <td key={col.k} style={{padding:"8px 10px",fontSize:12,color:"#475569",whiteSpace:"nowrap"}}>{val} <span title={c.pagos.length+" pagos en este REP"} style={{fontSize:9,padding:"1px 5px",borderRadius:8,background:"#eef4ff",color:BRAND,fontWeight:700}}>+{c.pagos.length-1}</span></td>;
          }
          return <td key={col.k} title={col.t?col.t(c):undefined} style={{padding:"8px 10px",fontSize:12,color:"#475569",whiteSpace:"nowrap",maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",textAlign:isNum?"right":"left"}}>{val}</td>;
        })}
        <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>
          <button
            onClick={function(){if(!c._raw)return; var a=document.createElement("a"); a.href="data:text/xml;charset=utf-8,"+encodeURIComponent(c._raw); a.download="CFDI_"+c.uuid.substring(0,8)+".xml"; a.click();}}
            disabled={!c._raw}
            title={c._raw?"Descargar XML":"XML no disponible"}
            style={{background:"none",border:"none",cursor:c._raw?"pointer":"not-allowed",fontSize:16,padding:"2px 3px",opacity:c._raw?1:0.3}}>
            📄
          </button>
          <CFDIPDFCell uid={p.uid} cfdi={c}/>
          <button
            onClick={function(){if(!window.confirm("¿Eliminar este CFDI? Esta accion no se puede deshacer."))return; p.onDelete(c.uuid);}}
            title="Eliminar CFDI"
            style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#94a3b8",fontWeight:600,marginLeft:6}}
            onMouseEnter={function(e){e.currentTarget.style.color="#ef4444";}} onMouseLeave={function(e){e.currentTarget.style.color="#94a3b8";}}>
            Eliminar
          </button>
        </td>
      </tr>
    ];
    if(isExp){
      out.push(
        <tr key={c.uuid+i+"-exp"} style={{borderBottom:"1px solid #f0f0f0"}}>
          <td colSpan={totalCols} style={{padding:"10px 16px 16px 32px",background:"#f8fafc"}}>
            {!c.pagos||!c.pagos.length?(
              <div style={{fontSize:12,color:"#94a3b8",fontStyle:"italic"}}>Sin detalle de pagos disponible en este CFDI (requiere reprocesar el XML original).</div>
            ):c.pagos.map(function(pg,pi){
              return (
                <div key={pi} style={{marginBottom:pi<c.pagos.length-1?14:0}}>
                  <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:6}}>
                    Pago {c.pagos.length>1?(pi+1)+" de "+c.pagos.length+" — ":""}{cfdiDate(pg.fechaPago)} · Forma de pago {pg.formaDePagoP||"—"} · {cfdiToMXN(pg.monto||0)}
                  </div>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:11,background:"#fff",border:"1px solid #e2e8f0",borderRadius:6}}>
                    <thead>
                      <tr style={{background:"#f1f5f9"}}>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>Base IVA Tras. 16%</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>IVA Tras. 16%</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>IVA Exento</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>IVA Retenido</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>ISR Retenido</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>Saldo anterior</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>Importe pagado</th>
                        <th style={{padding:"5px 8px",textAlign:"right",color:"#64748b",fontWeight:600}}>Saldo actual</th>
                        <th style={{padding:"5px 8px",textAlign:"left",color:"#64748b",fontWeight:600}}>UUID CFDI</th>
                        <th style={{padding:"5px 8px",textAlign:"left",color:"#64748b",fontWeight:600}}>Folio CFDI</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(pg.doctosRelacionados||[]).map(function(dr,di){
                        return (
                          <tr key={di} style={{borderTop:"1px solid #f0f0f0"}}>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.baseIva16||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.ivaTrasladado16||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.ivaExento||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.ivaRetenido||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.isrRetenido||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.impSaldoAnt||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.impPagado||0)}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#475569"}}>{cfdiToMXN(dr.impSaldoInsoluto||0)}</td>
                            <td title={dr.idDocumento} style={{padding:"5px 8px",color:"#475569"}}>{dr.idDocumento?dr.idDocumento.slice(0,8)+"…":"—"}</td>
                            <td style={{padding:"5px 8px",color:"#475569"}}>{facturaLabel(dr.idDocumento)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </td>
        </tr>
      );
    }
    return out;
  });
  return(
    <div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:6}}><label style={{fontSize:12,color:"#64748b",fontWeight:600}}>Desde</label><Inp type="date" value={desde} onChange={function(e){setDesde(e.target.value);}} sx={{width:"auto"}}/></div>
        <div style={{display:"flex",alignItems:"center",gap:6}}><label style={{fontSize:12,color:"#64748b",fontWeight:600}}>Hasta</label><Inp type="date" value={hasta} onChange={function(e){setHasta(e.target.value);}} sx={{width:"auto"}}/></div>
        {(desde||hasta)?<button onClick={function(){setDesde("");setHasta("");}} style={{padding:"6px 12px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#64748b",fontSize:12,cursor:"pointer"}}>Limpiar</button>:null}
        <span style={{fontSize:12,color:"#94a3b8",marginLeft:"auto"}}>{sorted.length+" de "+lista.length}</span>
      </div>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{borderBottom:"1px solid #e2e8f0",background:"#f8f8f8"}}>
              {isCob?<th style={{padding:"8px 4px"}}></th>:null}
              {COLS.map(function(col){return <th key={col.k} onClick={function(){doSort(col.k);}} style={{padding:"8px 10px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:11,whiteSpace:"nowrap",cursor:"pointer",userSelect:"none"}}>{col.l}{arr(col.k)}</th>;})}
              <th style={{padding:"8px 10px"}}></th>
            </tr>
            <tr style={{borderBottom:"2px solid #e2e8f0",background:"#f8fafc"}}>
              {isCob?<td></td>:null}
              {COLS.map(function(col){return <td key={col.k} style={{padding:"4px 6px"}}><input value={colF[col.k]||""} onChange={function(e){setF(col.k,e.target.value);}} placeholder="Filtrar..." style={{width:"100%",border:"1px solid #e2e8f0",borderRadius:5,padding:"3px 6px",fontSize:11,background:"#fff",boxSizing:"border-box",outline:"none",minWidth:60}}/></td>;})}
              <td></td>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    </div>
  );
}

export function CFDIModule(p) {
  var uid = p.user.id;
  var role = p.role || p.user.role;
  var isElevated = role==="contador"||role==="superadmin";
  var showClientSelector = isElevated && Array.isArray(p.clients) && p.clients.length>0 && typeof p.onChangeClient==="function";
  var [tab,     setTab]     = useState("importar");
  var [cfdis,   setCfdis]   = useState([]);
  var [cfg,     setCfg]     = useState({rfc:"",nombre:"",regimen:"",cp:""});
  var [showCfg, setShowCfg] = useState(false);
  var [loaded,  setLoaded]  = useState(false);
  var [importSummary,setImportSummary]=useState(null);
  var [importError,setImportError]=useState(null);
  var [actionError,setActionError]=useState(null);
  var [importing,setImporting]=useState(false);
  var [dragOver,setDragOver]=useState(false);
  var [menuOpen,setMenuOpen]=useState(false); var menuRef=useRef();

  useEffect(function(){
    Promise.all([
      apiFetch("/catalogs/"+uid+"/cfdi_config").then(function(r){return r.json();}),
      apiFetch("/catalogs/"+uid+"/cfdis").then(function(r){return r.json();}),
    ]).then(function(results){
      var cfgD=results[0]; var cfdiD=results[1];
      var loadedCfg=(cfgD.data&&cfgD.data.rfc!==undefined)?cfgD.data:{rfc:"",nombre:"",regimen:"",cp:""};
      if(cfgD.data&&cfgD.data.rfc!==undefined) setCfg(loadedCfg);
      if(cfdiD.data&&cfdiD.data.length) setCfdis(classifyCFDIs(cfdiD.data,loadedCfg.rfc));
      setLoaded(true);
    }).catch(function(){setLoaded(true);});
  },[uid]);

  useEffect(function(){
    function fn(e){if(menuRef.current&&!menuRef.current.contains(e.target))setMenuOpen(false);}
    document.addEventListener("mousedown",fn);
    return function(){document.removeEventListener("mousedown",fn);};
  },[]);

  useEffect(function(){
    if (!window.JSZip) {
      var z = document.createElement("script");
      z.src = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
      document.head.appendChild(z);
    }
  },[]);

  function saveCfdiConfig(nc) {
    return apiFetch("/catalogs/"+uid+"/cfdi_config",{method:"POST",body:JSON.stringify({data:nc})}).then(function(r){
      if (!r.ok) {
        return r.json().catch(function(){return {};}).then(function(d){
          throw new Error(d.error || ("El servidor rechazo el guardado (HTTP "+r.status+")."));
        });
      }
      return r;
    });
  }

  async function saveCfg(nc) {
    setShowCfg(false);
    try {
      await saveCfdiConfig(nc);
    } catch (err) {
      console.error("[CFDI-CFG] No se pudo guardar la configuracion fiscal:", err);
      setActionError("No se pudo guardar la configuracion fiscal (RFC/nombre/regimen) en el servidor (Motivo: "+(err.message||"error desconocido")+"). El cambio no se aplico; la configuracion sigue siendo la anterior.");
      return;
    }
    setCfg(nc);
    var reclassified = classifyCFDIs(cfdis, nc.rfc);
    try {
      await saveCfdisCatalog(reclassified);
      setCfdis(reclassified);
    } catch (err) {
      console.error("[CFDI-CFG] No se pudo guardar la reclasificacion tras cambiar el RFC:", err);
      setActionError("Se actualizo el RFC, pero no se pudo guardar la reclasificacion de los CFDIs en el servidor (Motivo: "+(err.message||"error desconocido")+"). Los CFDIs siguen clasificados con el RFC anterior; abre la configuracion y guarda de nuevo.");
    }
  }

  function isPdfFile(file){return file.name.toLowerCase().endsWith(".pdf");}

  function parseOtherFile(file) {
    var name = file.name.toLowerCase();
    var nowIso = new Date().toISOString();
    function stamp(list){return list.map(function(c){return Object.assign({},c,{_fileName:file.name,importedAt:nowIso});});}
    if (name.endsWith(".zip")) {
      return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onload = function(ev){
          window.JSZip.loadAsync(ev.target.result).then(function(zip){
            var xmlPs=[], csvFile=null;
            zip.forEach(function(path,f){
              var lp=path.toLowerCase();
              if(lp.endsWith(".xml")) xmlPs.push(f.async("string").then(function(t){return parseCFDIxml(t);}));
              else if((lp.endsWith(".txt")||lp.endsWith(".csv"))&&!csvFile) csvFile=f;
            });
            if(xmlPs.length>0){
              Promise.all(xmlPs).then(function(arr){
                var validos=arr.filter(Boolean);
                if(!validos.length&&csvFile){
                  csvFile.async("string").then(function(t){resolve(stamp(parseCFDIcsv(t)));});
                } else {
                  resolve(stamp(validos));
                }
              });
            } else if(csvFile){
              csvFile.async("string").then(function(t){resolve(stamp(parseCFDIcsv(t)));});
            } else {
              resolve([]);
            }
          });
        };
        reader.readAsArrayBuffer(file);
      });
    } else if (name.endsWith(".xml")) {
      return new Promise(function(resolve) {
        var r=new FileReader();
        r.onload=function(ev){
          var parsed=parseCFDIxml(ev.target.result);
          resolve(parsed?stamp([parsed]):[]);
        };
        r.readAsText(file,"utf-8");
      });
    } else {
      return new Promise(function(resolve) {
        var r=new FileReader();
        r.onload=function(ev){resolve(stamp(parseCFDIcsv(ev.target.result)));};
        r.readAsText(file,"utf-8");
      });
    }
  }

  function processPdfFile(file, knownUuidsSet) {
    function doUpload(matchedUuid) {
      var fd = new FormData();
      fd.append("file", file, file.name);
      return apiFetch("/cfdi/pdf/"+uid+"/"+matchedUuid, {method:"POST", body:fd})
        .then(function(r){
          return r.json().catch(function(){return {};}).then(function(d){
            if (!r.ok) return {ok:false, fileName:file.name, reason: d.error || ("Error HTTP "+r.status)};
            return {ok:true, fileName:file.name, uuid:matchedUuid};
          });
        })
        .catch(function(){ return {ok:false, fileName:file.name, reason:"Error de conexion al subir el PDF."}; });
    }
    var base = file.name.replace(/\.pdf$/i,"").trim().toUpperCase();
    if (knownUuidsSet.has(base)) return doUpload(base);
    return extraerUUIDdePDF(file).then(function(extracted){
      if (extracted && knownUuidsSet.has(extracted)) return doUpload(extracted);
      if (!extracted) return {ok:false, fileName:file.name, reason:"No se pudo leer un folio fiscal (UUID) en el contenido del PDF."};
      return {ok:false, fileName:file.name, reason:"El folio fiscal encontrado en el PDF no corresponde a ningun CFDI importado."};
    }).catch(function(){
      return {ok:false, fileName:file.name, reason:"No se pudo leer el archivo PDF."};
    });
  }

  function saveCfdisCatalog(data) {
    return apiFetch("/catalogs/"+uid+"/cfdis",{method:"POST",body:JSON.stringify({data:data})}).then(function(r){
      if (!r.ok) {
        return r.json().catch(function(){return {};}).then(function(d){
          throw new Error(d.error || ("El servidor rechazo el guardado (HTTP "+r.status+")."));
        });
      }
      return r;
    });
  }

  async function handleImportBatch(fileList) {
    if (!fileList || !fileList.length || importing) return;
    var files = Array.from(fileList);
    var pdfFiles = files.filter(isPdfFile);
    var otherFiles = files.filter(function(f){return !isPdfFile(f);});
    var baseCfdis = cfdis;
    setImporting(true);
    setImportError(null);
    try {
      var results = await Promise.all(otherFiles.map(parseOtherFile));
      var nuevosCandidatos = results.reduce(function(acc,arr){return acc.concat(arr);},[]);
      var clasificados = classifyCFDIs(nuevosCandidatos, cfg.rfc);
      var existingUuids=new Set(baseCfdis.map(function(c){return (c.uuid||"").toUpperCase();}));
      var nuevos=clasificados.filter(function(c){return c.uuid&&!existingUuids.has(c.uuid.toUpperCase());});
      var xmlImportedCount=nuevos.length;
      var xmlSkippedCount=clasificados.length-nuevos.length;
      var merged=baseCfdis.concat(nuevos);

      // Persistimos primero; si el guardado falla, no tocamos el estado local
      // ni lo contamos como importado (evita el falso "exito" cuando el
      // backend/proxy rechaza el guardado).
      await saveCfdisCatalog(merged);
      setCfdis(merged);

      var knownUuids=new Set(merged.filter(function(c){return c.uuid;}).map(function(c){return c.uuid.toUpperCase();}));
      var pdfResults = await Promise.all(pdfFiles.map(function(f){return processPdfFile(f,knownUuids);}));
      var pdfOk=pdfResults.filter(function(r){return r.ok;});
      var pdfRejected=pdfResults.filter(function(r){return !r.ok;});
      if (pdfOk.length) {
        var nowIso=new Date().toISOString();
        var byUuid={}; pdfOk.forEach(function(r){byUuid[r.uuid]=r;});
        var updated=merged.map(function(c){
          return byUuid[c.uuid] ? Object.assign({},c,{pdfFileName:byUuid[c.uuid].fileName,pdfImportedAt:nowIso}) : c;
        });
        try {
          await saveCfdisCatalog(updated);
          setCfdis(updated);
        } catch (pdfSaveErr) {
          console.error("[CFDI-IMPORT] No se pudo guardar la vinculacion de PDFs:", pdfSaveErr);
          setImportError("Los XML se importaron, pero no se pudo guardar la vinculacion de los PDF ("+pdfSaveErr.message+"). Intenta subir los PDF de nuevo.");
        }
      }
      setImportSummary({
        xmlImportedCount:xmlImportedCount, xmlSkippedCount:xmlSkippedCount,
        pdfOkCount:pdfOk.length,
        pdfRejected:pdfRejected.map(function(r){return {fileName:r.fileName,reason:r.reason};}),
      });
    } catch (err) {
      console.error("[CFDI-IMPORT] Fallo el guardado de los CFDIs importados:", err);
      setImportError("No se pudieron guardar los CFDIs en el servidor. No se importo nada. Motivo: "+(err.message||"error desconocido")+". Intenta de nuevo con un lote mas pequeno o contacta a soporte.");
    } finally {
      setImporting(false);
    }
  }

  function getByCategoria(cat){return cfdis.filter(function(c){return c.categoria===cat;});}

  function getImportRows(){
    var rows=cfdis.filter(function(c){return c.importedAt||c.pdfImportedAt;}).map(function(c){
      var fecha=(c.pdfImportedAt&&(!c.importedAt||c.pdfImportedAt>c.importedAt))?c.pdfImportedAt:c.importedAt;
      return {cfdi:c, fileName:c._fileName||c.pdfFileName||(c.uuid?c.uuid.slice(0,8)+"…":"—"), fecha:fecha};
    });
    rows.sort(function(a,b){return (b.fecha||"").localeCompare(a.fecha||"");});
    return rows.slice(0,20);
  }

  async function handleDeleteCFDI(uuid) {
    var updated = cfdis.filter(function(c){return c.uuid!==uuid;});
    try {
      await saveCfdisCatalog(updated);
      setCfdis(updated);
    } catch (err) {
      console.error("[CFDI-DELETE] No se pudo eliminar el CFDI:", err);
      setActionError("No se pudo eliminar el CFDI. El cambio no se guardo en el servidor (Motivo: "+(err.message||"error desconocido")+"). El CFDI sigue en tu lista.");
    }
  }

  var navBtns = CFDI_TABS.map(function(t){
    var cnt = t.k==="importar" ? null : getByCategoria(t.k).length;
    return (
      <button key={t.k} onClick={function(){setTab(t.k);}} style={{display:"block",width:"100%",textAlign:"left",padding:"9px 12px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:tab===t.k?"rgba(255,255,255,0.2)":"transparent",color:"#fff",opacity:tab===t.k?1:0.65}}>
        {t.l}{cnt!==null?<span style={{marginLeft:6,fontSize:10,background:"rgba(255,255,255,0.2)",borderRadius:10,padding:"1px 7px"}}>{cnt}</span>:null}
      </button>
    );
  });

  function IconDot(){
    return <div style={{width:40,height:40,borderRadius:12,background:BRAND+"18",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:12,flexShrink:0}}><div style={{width:18,height:18,borderRadius:5,background:BRAND}}/></div>;
  }

  function renderImportar(){
    var featureCards=[
      {t:"Organizacion automatica", d:"Cada CFDI se clasifica en Ingresos, Gastos, Cobros, Nomina, etc. segun tu RFC configurado."},
      {t:"Sin duplicados",          d:"Detectamos el UUID de cada comprobante para evitar cargar el mismo CFDI dos veces."},
      {t:"Emparejamiento por UUID", d:"Los PDF se vinculan automaticamente con su XML correspondiente, sin importar el orden en que los subas."},
    ];
    var importRows=getImportRows();
    return(
      <div style={{maxWidth:760}}>
        <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:"0 0 6px"}}>Subir XML / PDF</h1>
        <p style={{color:"#64748b",fontSize:13,margin:"0 0 20px"}}>Carga archivos del portal del SAT. Puedes soltar o seleccionar varios XML y PDF a la vez.</p>

        {showClientSelector?(
          <div style={{marginBottom:16}}>
            <Lbl c="Cliente"/>
            <Slct value={p.user.id} onChange={function(e){
              var newId=parseInt(e.target.value,10);
              var c=p.clients.find(function(x){return x.id===newId;});
              if(c) p.onChangeClient(c);
            }} sx={{maxWidth:320}}>
              {p.clients.map(function(c){return <option key={c.id} value={c.id}>{c.name}</option>;})}
            </Slct>
          </div>
        ):null}

        {!cfg.rfc?<div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#d97706",marginBottom:16,fontWeight:600}}>Configura tu RFC en el menu de usuario para clasificar correctamente los comprobantes.</div>:null}

        <label
          onDragOver={function(e){e.preventDefault();setDragOver(true);}}
          onDragLeave={function(){setDragOver(false);}}
          onDrop={function(e){e.preventDefault();setDragOver(false);handleImportBatch(e.dataTransfer.files);}}
          style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:14,border:"2px dashed "+(dragOver?BRAND:"#bbb"),borderRadius:14,padding:"40px 24px",fontSize:14,color:"#888",cursor:importing?"default":"pointer",background:dragOver?BRAND+"0a":"#fafafa",textAlign:"center",transition:"all .15s"}}>
          <span style={{fontSize:40}}>📥</span>
          <div>
            <p style={{margin:0,fontWeight:700,color:"#374151",fontSize:15}}>{importing?"Procesando archivos...":"Arrastra tus archivos aqui o haz clic para seleccionarlos"}</p>
            <p style={{margin:"6px 0 0",fontSize:12}}>Puedes mezclar XML y PDF en la misma zona. Tambien aceptamos ZIP, TXT o CSV del portal del SAT.</p>
          </div>
          <div style={{display:"flex",gap:10}}>
            <span style={{padding:"5px 16px",borderRadius:8,background:"#fff",border:"1px solid #dde3f0",fontSize:12,fontWeight:700,color:BRAND}}>XML</span>
            <span style={{padding:"5px 16px",borderRadius:8,background:"#fff",border:"1px solid #dde3f0",fontSize:12,fontWeight:700,color:BRAND}}>PDF</span>
          </div>
          <input type="file" accept=".csv,.zip,.txt,.xml,.pdf" multiple disabled={importing} style={{display:"none"}} onChange={function(e){handleImportBatch(e.target.files);e.target.value="";}}/>
        </label>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:14,marginTop:20}}>
          {featureCards.map(function(f){
            return (
              <Card key={f.t} sx={{padding:"16px 18px"}}>
                <IconDot/>
                <p style={{margin:"0 0 4px",fontSize:13,fontWeight:700,color:"#0f172a"}}>{f.t}</p>
                <p style={{margin:0,fontSize:12,color:"#64748b"}}>{f.d}</p>
              </Card>
            );
          })}
        </div>

        {importError?(
          <div style={{marginTop:20,background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"14px 18px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
              <p style={{margin:0,fontSize:13,fontWeight:700,color:"#dc2626"}}>⚠️ No se guardaron los CFDIs</p>
              <button onClick={function(){setImportError(null);}} style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16,lineHeight:1}}>X</button>
            </div>
            <p style={{margin:"6px 0 0",fontSize:12,color:"#991b1b"}}>{importError}</p>
          </div>
        ):null}

        {importSummary?(
          <div style={{marginTop:20,background:"#fff",border:"1px solid #e2e8f0",borderRadius:10,padding:"14px 18px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <p style={{margin:0,fontSize:13,fontWeight:700,color:"#0f172a"}}>Resumen de la importacion</p>
              <button onClick={function(){setImportSummary(null);}} style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16,lineHeight:1}}>X</button>
            </div>
            <div style={{display:"flex",gap:18,flexWrap:"wrap",marginTop:8,fontSize:12,color:"#374151"}}>
              <span>📄 {importSummary.xmlImportedCount} XML importados</span>
              <span>🖨️ {importSummary.pdfOkCount} PDF vinculados y subidos</span>
              {importSummary.xmlSkippedCount>0?<span>♻️ {importSummary.xmlSkippedCount} CFDI{importSummary.xmlSkippedCount===1?"":"s"} omitido{importSummary.xmlSkippedCount===1?"":"s"} por duplicado</span>:null}
              {importSummary.pdfRejected.length>0?<span style={{color:"#dc2626"}}>⚠️ {importSummary.pdfRejected.length} PDF rechazado{importSummary.pdfRejected.length===1?"":"s"}</span>:null}
            </div>
            {importSummary.pdfRejected.length>0?(
              <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid #f1f5f9"}}>
                <p style={{margin:"0 0 6px",fontSize:12,fontWeight:700,color:"#dc2626"}}>PDF que no se pudieron vincular:</p>
                <ul style={{margin:0,paddingLeft:18,fontSize:12,color:"#64748b"}}>
                  {importSummary.pdfRejected.map(function(r,i){return <li key={i}><strong style={{color:"#374151"}}>{r.fileName}</strong> — {r.reason}</li>;})}
                </ul>
              </div>
            ):null}
          </div>
        ):null}

        <div style={{marginTop:24}}>
          <p style={{fontSize:13,fontWeight:700,color:"#0f172a",margin:"0 0 10px"}}>Archivos importados recientemente</p>
          {importRows.length===0?(
            <div style={{textAlign:"center",padding:"28px 0",color:"#94a3b8",fontSize:13,background:"#fff",border:"1px solid #e2e8f0",borderRadius:10}}>Aun no has importado archivos en esta sesion de trabajo.</div>
          ):(
            <div style={{overflowX:"auto",background:"#fff",border:"1px solid #e2e8f0",borderRadius:10}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr style={{borderBottom:"1px solid #e2e8f0",background:"#f8fafc"}}>
                    <th style={{padding:"8px 12px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:11}}>Archivo</th>
                    <th style={{padding:"8px 12px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:11}}>Tipo</th>
                    <th style={{padding:"8px 12px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:11}}>Fecha de importacion</th>
                    <th style={{padding:"8px 12px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:11}}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {importRows.map(function(row){
                    var c=row.cfdi;
                    return (
                      <tr key={c.uuid} style={{borderBottom:"1px solid #f0f0f0"}}>
                        <td style={{padding:"8px 12px",color:"#374151",maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={row.fileName}>{row.fileName}</td>
                        <td style={{padding:"8px 12px"}}><span style={{fontSize:10,padding:"2px 8px",borderRadius:10,background:BRAND+"15",color:BRAND,fontWeight:700}}>{CAT_LABELS[c.categoria]||c.categoria}</span></td>
                        <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{row.fecha?new Date(row.fecha).toLocaleString("es-MX",{dateStyle:"short",timeStyle:"short"}):"—"}</td>
                        <td style={{padding:"8px 12px",whiteSpace:"nowrap"}}>
                          <button
                            onClick={function(){if(!c._raw)return; var a=document.createElement("a"); a.href="data:text/xml;charset=utf-8,"+encodeURIComponent(c._raw); a.download="CFDI_"+c.uuid.substring(0,8)+".xml"; a.click();}}
                            disabled={!c._raw}
                            title={c._raw?"Descargar XML":"XML no disponible"}
                            style={{background:"none",border:"none",cursor:c._raw?"pointer":"not-allowed",fontSize:16,padding:"2px 3px",opacity:c._raw?1:0.3}}>
                            📄
                          </button>
                          <CFDIPDFCell uid={uid} cfdi={c}/>
                          <button
                            onClick={function(){if(!window.confirm("¿Eliminar este CFDI? Esta accion no se puede deshacer."))return; handleDeleteCFDI(c.uuid);}}
                            title="Eliminar CFDI"
                            style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#94a3b8",fontWeight:600,marginLeft:6}}
                            onMouseEnter={function(e){e.currentTarget.style.color="#ef4444";}} onMouseLeave={function(e){e.currentTarget.style.color="#94a3b8";}}>
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  }

  function renderLista(cat){
    var lbs=Object.assign({},CAT_LABELS,{cobros:"Cobros recibidos"});
    var lista=getByCategoria(cat);
    var tot=lista.reduce(function(s,c){return s+c.total;},0);
    var cans=lista.filter(function(c){return(c.estatus||"").toLowerCase().includes("cancel");}).length;
    return (
      <div style={{display:"flex",flexDirection:"column",gap:16}}>
        <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>{lbs[cat]}</h1>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10}}>
          <KPI label="Total"      value={cfdiToMXN(tot)} color={BRAND} bg="#eef4ff" border="#c7d2fe"/>
          <KPI label="CFDIs"      value={lista.length+""} color="#64748b" bg="#f8fafc" border="#e2e8f0"/>
          <KPI label="Vigentes"   value={(lista.length-cans)+""} color="#16a34a" bg="#f0fdf4" border="#bbf7d0"/>
          <KPI label="Cancelados" value={cans+""} color="#dc2626" bg="#fef2f2" border="#fecaca"/>
        </div>
        <Card><CFDITabla lista={lista} cat={cat} uid={uid} all={cfdis} onDelete={handleDeleteCFDI}/></Card>
      </div>
    );
  }

  if(!loaded) return <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:"#64748b"}}>Cargando...</div>;

  return (
    <div style={{display:"flex",minHeight:"100vh",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      <div style={{width:210,background:BRAND,minHeight:"100vh",display:"flex",flexDirection:"column",flexShrink:0}}>
        <div style={{padding:"20px 16px 16px",borderBottom:"1px solid rgba(255,255,255,0.1)",display:"flex",alignItems:"center",gap:10}}>
          <KofidesLogo size={28}/>
          <div>
            <p style={{color:"#fff",fontWeight:800,fontSize:15,margin:0,fontFamily:"Georgia,serif",letterSpacing:2}}>KOFIDES</p>
            <p style={{color:"rgba(255,255,255,0.5)",fontSize:11,margin:"2px 0 0"}}>CFDIs SAT</p>
          </div>
        </div>
        <div style={{flex:1,padding:"12px 8px",display:"flex",flexDirection:"column",gap:2}}>
          {navBtns}
          <div style={{flex:1}}/>
          <div style={{borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:10,marginTop:6}}>
            <button onClick={function(){setShowCfg(true);}} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 12px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:"transparent",color:"rgba(255,255,255,0.65)"}}>
              {cfg.rfc?"RFC: "+cfg.rfc:"Configurar RFC"}
            </button>
            <button onClick={p.onBack} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 12px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:"transparent",color:"rgba(255,255,255,0.55)"}}>Inicio</button>
            <button onClick={p.onLogout} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 12px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:"transparent",color:"rgba(255,100,100,0.8)"}}>Cerrar sesion</button>
          </div>
        </div>
      </div>
      <div style={{flex:1,background:"#f1f5f9",minHeight:"100vh",display:"flex",flexDirection:"column"}}>
        <div style={{background:"#fff",borderBottom:"1px solid #dde3f0",padding:"12px 24px",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
          <div ref={menuRef} style={{position:"relative"}}>
            <div onClick={function(){setMenuOpen(function(o){return !o;});}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",padding:"4px 8px",borderRadius:8}} onMouseEnter={function(e){e.currentTarget.style.background="#f1f5f9";}} onMouseLeave={function(e){e.currentTarget.style.background="transparent";}}>
              <div style={{width:32,height:32,background:BRAND,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:700}}>{p.user.name[0]}</div>
              <span style={{fontSize:13,fontWeight:600,color:"#374151"}}>{p.user.name}</span>
            </div>
            {menuOpen?(
              <div style={{position:"absolute",top:"calc(100% + 8px)",right:0,background:"#fff",borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",border:"1px solid #e2e8f0",minWidth:180,zIndex:100}}>
                <button onClick={function(){setMenuOpen(false);setShowCfg(true);}} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 16px",border:"none",background:"transparent",fontSize:13,fontWeight:600,color:"#374151",cursor:"pointer",borderRadius:"10px 10px 0 0"}} onMouseEnter={function(e){e.currentTarget.style.background="#f8fafc";}} onMouseLeave={function(e){e.currentTarget.style.background="transparent";}}>Configurar RFC</button>
                <div style={{height:1,background:"#f1f5f9"}}/>
                <button onClick={function(){setMenuOpen(false);p.onBack();}} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 16px",border:"none",background:"transparent",fontSize:13,fontWeight:600,color:"#374151",cursor:"pointer"}} onMouseEnter={function(e){e.currentTarget.style.background="#f8fafc";}} onMouseLeave={function(e){e.currentTarget.style.background="transparent";}}>Inicio</button>
                <div style={{height:1,background:"#f1f5f9"}}/>
                <button onClick={function(){setMenuOpen(false);p.onLogout();}} style={{display:"block",width:"100%",textAlign:"left",padding:"10px 16px",border:"none",background:"transparent",fontSize:13,fontWeight:600,color:"#dc2626",cursor:"pointer",borderRadius:"0 0 10px 10px"}} onMouseEnter={function(e){e.currentTarget.style.background="#fef2f2";}} onMouseLeave={function(e){e.currentTarget.style.background="transparent";}}>Cerrar sesion</button>
              </div>
            ):null}
          </div>
        </div>
        <div style={{padding:24,flex:1}}>
          {actionError?(
            <div style={{marginBottom:16,background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"14px 18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
                <p style={{margin:0,fontSize:13,fontWeight:700,color:"#dc2626"}}>⚠️ {actionError}</p>
                <button onClick={function(){setActionError(null);}} style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16,lineHeight:1,flexShrink:0}}>X</button>
              </div>
            </div>
          ):null}
          <div>
            {tab==="importar"?renderImportar():null}
            {tab!=="importar"&&cfdis.length===0?(
              <div style={{textAlign:"center",padding:"80px 20px",color:"#94a3b8"}}>
                <div style={{fontSize:56,marginBottom:12}}>📄</div>
                <p style={{fontSize:16,fontWeight:600,color:"#64748b",margin:"0 0 8px"}}>Sin CFDIs cargados</p>
                <p style={{fontSize:13}}>Ve a la pestana <strong>Importar</strong> para cargar tus archivos del SAT.</p>
              </div>
            ):null}
            {tab!=="importar"&&cfdis.length>0?renderLista(tab):null}
          </div>
        </div>
      </div>
      {showCfg?<CFDIConfigModal cfg={cfg} onSave={saveCfg} onClose={function(){setShowCfg(false);}}/>:null}
    </div>
  );
}

